import $ from 'jquery'
import 'jquery-validation/dist/jquery.validate.min'

export default {
  init() {
    $.extend(jQuery.validator.messages, {
      required: 'Ce champs est requis',
      minlength: 'Le mot de passe doit contenir au moins 6 caractères',
      equalTo: 'Les mots de passe doivent être identiques',
    });

    $('form').validate({
      rules: {
        'password-verif': {
          equalTo: 'input[name="password"]',
        },
      },
      submitHandler: function(form) {
        form.submit();
      },
    })
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent-password-reset.js